'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:LogoutCtrl
 * @description
 * # LogoutCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('LogoutCtrl', function ($location, session) {
		session.logout().then((/**Account*/accountAfterLogout) => {
			if (accountAfterLogout?.admin) {
				$location.path('/admin')
				toastr.info('You are logged in as ' + accountAfterLogout.email + ' again', 'Exited Switch User');
			} else {
				$location.path('/')
				toastr.info('You are no longer logged in', 'Logout Successful');
			}
		});
	});
